import script from "./productList.vue?vue&type=script&setup=true&lang=ts"
export * from "./productList.vue?vue&type=script&setup=true&lang=ts"

import "./productList.vue?vue&type=style&index=0&id=7c9f2d5e&scoped=true&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c9f2d5e"]])

export default __exports__